import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import WorkOrderList from './pages/WorkOrder/WorkOrderList';
import WorkOrderForm from './pages/WorkOrder/WorkOrderForm';
import WorkOrderDetail from './pages/WorkOrder/WorkOrderDetail';
import CustomerList from './pages/Customer/CustomerList';
import CustomerForm from './pages/Customer/CustomerForm';
import CustomerDetail from './pages/Customer/CustomerDetail';
import StaffList from './pages/Staff/StaffList';
import StaffForm from './pages/Staff/StaffForm';
import StaffDetail from './pages/Staff/StaffDetail';
import SupplierList from './pages/Inventory/SupplierList';
import CategoryList from './pages/Inventory/CategoryList';
import InventoryList from './pages/Inventory/InventoryList';
import InventoryForm from './pages/Inventory/InventoryForm';
import InventoryDetail from './pages/Inventory/InventoryDetail';
import TransactionList from './pages/Transactions/TransactionList';
import TransactionForm from './pages/Transactions/TransactionForm';
import TransactionDetail from './pages/Transactions/TransactionDetail';  // ← PERBAIKI IMPORT
import Reports from './pages/Reports/Reports';
import Settings from './pages/Settings/Settings';

function App() {
  const ProtectedRoute = ({ children }) => {
    const isAuth = localStorage.getItem('eos7-auth') === 'true';
    return isAuth ? children : <Navigate to="/login" replace />;
  };

  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            
            {/* Work Order */}
            <Route path="work-orders" element={<WorkOrderList />} />
            <Route path="work-orders/new" element={<WorkOrderForm />} />
            <Route path="work-orders/edit/:id" element={<WorkOrderForm />} />
            <Route path="work-orders/:id" element={<WorkOrderDetail />} />
            
            {/* Customer */}
            <Route path="customers" element={<CustomerList />} />
            <Route path="customers/new" element={<CustomerForm />} />
            <Route path="customers/edit/:id" element={<CustomerForm />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            
            {/* Supplier */}
            <Route path="suppliers" element={<SupplierList />} />
            
            {/* Category */}
            <Route path="categories" element={<CategoryList />} />
            
            {/* Staff */}
            <Route path="staff" element={<StaffList />} />
            <Route path="staff/new" element={<StaffForm />} />
            <Route path="staff/edit/:id" element={<StaffForm />} />
            <Route path="staff/:id" element={<StaffDetail />} />

            {/* Inventory */}
            <Route path="inventory" element={<InventoryList />} />
            <Route path="inventory/new" element={<InventoryForm />} />
            <Route path="inventory/edit/:id" element={<InventoryForm />} />
            <Route path="inventory/:id" element={<InventoryDetail />} />

            {/* Transaction */}
            <Route path="transactions" element={<TransactionList />} />
            <Route path="transactions/new" element={<TransactionForm />} />
            <Route path="transactions/edit/:id" element={<TransactionForm />} />
            <Route path="transactions/:id" element={<TransactionDetail />} />  {/* ← SATU ROUTE */}
            
            {/* Reports */}
            <Route path="reports" element={<Reports />} />
            
            {/* Settings */}
            <Route path="settings" element={<Settings />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;